import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportBatchCodePDF = (data: {
  productName: string;
  mrp: number;
  ratePerUnit: string;
  batchCode: string;
  packedDate: string;
  measurement: string; // added
}) => {
  const { productName, mrp, ratePerUnit, batchCode, packedDate, measurement } = data;

  const doc = new jsPDF();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("Desiri - Product Batch Code", 14, 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Generated on: " + new Date().toLocaleDateString(), 14, 28);

  autoTable(doc, {
    startY: 40,
    head: [["Product Name", productName]],
    body: [
      ["MRP ", `${mrp}`],
      [`Rs per ${measurement}`, ratePerUnit],
      ["Batch Code", batchCode],
      ["Packed Date", packedDate],
    ],
    styles: { fontSize: 11 },
    headStyles: { fillColor: [0, 102, 51], textColor: 255 },
    margin: { left: 14, right: 14 },
  });

  doc.save(`BatchCode_${batchCode}.pdf`);
};
